module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.block) ? _c('v-btn', {
    attrs: {
      "block": "",
      "loading": _vm.form.busy,
      "disabled": _vm.form.busy,
      "type": "submit"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]) : (_vm.flat) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "color": _vm.color,
      "loading": _vm.form.busy,
      "disabled": _vm.form.busy,
      "type": "submit"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]) : _c('v-btn', {
    attrs: {
      "color": _vm.color,
      "loading": _vm.form.busy,
      "disabled": _vm.form.busy,
      "type": "submit"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3086ac","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/SubmitButton.vue
// module id = RFeq
// module chunks = 1